import { lazy } from 'react';

const VehiclesList = lazy(() => import('./VehiclesList'));
const VehicleManualUpload = lazy(() => import('./VehicleManualUpload'));
const LocationsList = lazy(() => import('./Locations/list'));
const AuctionsList = lazy(() => import('./AuctionsList'));
const AuctionDetail = lazy(() => import('./AuctionDetail'));
const AuctionDetailNew = lazy(() => import('./AuctionDetailNew'));
const TransferReport = lazy(() => import('./TransferReport/index'));
const TransferReportPdfViewer = lazy(() => import('./TransferReport/PdfViewerPage'));
const CustomersList = lazy(() => import('./CustomersList'));
const AccountsList = lazy(() => import('./AccountsList'));
const FakeBuyersList = lazy(() => import('./FakeBuyersList'));
const AccountLogsList = lazy(() => import('./AccountLogsList'));
const AdminSellers = lazy(() => import('./AdminSellers'));
const CustomerDetailPage = lazy(() => import('./CustomerDetailPage'));
const BuyerFeesPage = lazy(() => import('./BuyerFeesPage'));
const AuctionSummaryReportPage = lazy(() => import('./AuctionSummaryReportPage'));
const AuctionSummaryReportExportPage = lazy(() => import('../Shared/AucttionSummaryReportExport'));
const BuyerPurchaseReportPage = lazy(() => import('./BuyerPurchaseReport'));
const ListerSummaryReportPage = lazy(() => import('./ListerSummaryReportPage'));
const BuyersDocs = lazy(() => import('./Users/Documents/BuyerDocs'));
const DeclinedCardsPage = lazy(() => import('./DeclinedCardsPage'));
const AdditionalFeesPage = lazy(() => import('./AdditionalFeesPage'));
const BannersList = lazy(() => import('./BannersList'));
const TransactionsList = lazy(() => import('./TransactionsList'));
const SiteStatisticsDetails = lazy(() => import('./SiteStatisticsDetails'));
const SiteStatistics = lazy(() => import('./SiteStatistics'));
const Logs = lazy(() => import('./Logs'));

export {
  AccountLogsList,
  AccountsList,
  CustomersList,
  VehiclesList,
  VehicleManualUpload,
  LocationsList,
  AuctionsList,
  AuctionDetail,
  AuctionDetailNew,
  AdminSellers,
  CustomerDetailPage,
  BuyerFeesPage,
  AuctionSummaryReportPage,
  AuctionSummaryReportExportPage,
  ListerSummaryReportPage,
  BuyersDocs,
  DeclinedCardsPage,
  AdditionalFeesPage,
  BannersList,
  TransactionsList,
  SiteStatisticsDetails,
  SiteStatistics,
  Logs,
  FakeBuyersList,
  TransferReport,
  TransferReportPdfViewer,
  BuyerPurchaseReportPage
};
